/**
 * KAN-744: цифры карточки менеджера: клиентов, продаж, конверсия, отказов,
 * заказов, сумма заказов, процент с продаж и сумма к выплате (KAN-745).
 */
import { Card, CardContent } from '@/components/ui/card';
import { formatRub } from '@/lib/money';
import type { ManagerSummary } from '@/types/manager';
import { formatCommission, formatConversion, formatPayout } from '@/lib/managerFormat';

interface Props {
  summary: ManagerSummary;
}

export function ManagerSummaryCards({ summary }: Props): JSX.Element {
  const items: { key: string; label: string; value: string }[] = [
    { key: 'clients', label: 'Клиентов', value: String(summary.clients) },
    { key: 'sales', label: 'Продаж', value: String(summary.sales) },
    { key: 'conversion', label: 'Конверсия в продажу', value: formatConversion(summary.conversion_pct) },
    { key: 'refused', label: 'Отказов', value: String(summary.refused) },
    { key: 'orders', label: 'Заказов', value: String(summary.orders_count) },
    { key: 'orders-sum', label: 'Сумма заказов', value: formatRub(summary.orders_sum) },
    { key: 'commission', label: 'Процент с продаж', value: formatCommission(summary.commission_pct) },
    { key: 'payout', label: 'К выплате', value: formatPayout(summary.payout) },
  ];
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4" data-testid="manager-summary">
      {items.map((item) => (
        <Card key={item.key}>
          <CardContent className="p-4">
            <p className="text-xs text-gray-500">{item.label}</p>
            <p
              className="mt-1 text-xl font-semibold tabular-nums text-gray-900"
              data-testid={`manager-summary-${item.key}`}
            >
              {item.value}
            </p>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
